import { SonarRecord } from '@ui/records';
import { PeriscopeSfFieldUpdate, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

export type RecordClickHandler = (record: PeriscopeSfFieldUpdate) => void;

export interface PeriscopeFieldUpdateProps {
	onClick?: RecordClickHandler;
	record: PeriscopeSfFieldUpdate;
	showType?: boolean;
}

export const PeriscopeFieldUpdate: React.FC<PeriscopeFieldUpdateProps> = ({ onClick, record, showType }) => {
	const handleClick = useCallback(() => {
		if (onClick) {
			onClick(record);
		}
	}, [ record, onClick ]);

	return (
		<SonarRecord
			isActive={ record.isActive }
			name={ record.displayName }
			onClick={ handleClick }
			showType={ showType }
			sonarObjectId={ record.sonarObjectId }
			sonarObjectType={ SonarObjectType.SalesforceFieldUpdate } />
	);
};
